import * as React from "react";
import styles from './SkeletonStrip.module.scss';

interface SkeletonStripProps {
    cards?: number;
}

const SkeletonCard: React.FC = () => (
    <div className={styles.skeletonStrip__card}>
        <div className={styles.skeletonStrip__cardImg} />
        <div className={styles.skeletonStrip__cardContent}>
            <div className={styles.skeletonStrip__cardTitle} />
            <div className={styles.skeletonStrip__cardDescription} />
        </div>
    </div>
);

export const SkeletonStrip: React.FC<SkeletonStripProps> = ({cards = 8}) => (
    <div className={styles.skeletonStrip__container}>
        <div className={styles.skeletonStrip__title} />
        <div className={styles.skeletonStrip__list}>
            {Array.from({length: cards}, (_, i) => <SkeletonCard key={i} />)}
        </div>
    </div>
);
